import { render, staticRenderFns } from "./route-slide-image.vue?vue&type=template&id=635f30ca&"
import script from "./route-slide-image.vue?vue&type=script&lang=ts&"
export * from "./route-slide-image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports